import React, {useContext} from "react"
import {ImageContainer, SearchBannerImage} from "./components"
import {ImageProps} from "./models"
import {useUniqueKey, getSearchBannerComponentTestId, replaceSiteUrl, SearchBannerContext} from "../utils"
import TrackVisualPillsClick from "../../../events/trackEvent/events/trackVisualPillsClick"
import {StyledLink} from "../ImageChips/components"

export const Image = ({overrideStyles, content, isIntelRecs}: ImageProps) => {
    const {components} = content
    const {siteUrl} = useContext(SearchBannerContext)
    const imageKeys = useUniqueKey(components?.length ?? 0)
    const containerStyles = {alignment: overrideStyles?.alignment}
    const imageStyles = {
        objectFit: overrideStyles?.objectFit,
        mobileObjectFit: overrideStyles?.mobileObjectFit,
        desktopObjectPosition: overrideStyles?.desktopObjectPosition,
        mobileObjectPosition: overrideStyles?.mobileObjectPosition,
        desktopMinHeight: overrideStyles?.desktopMinHeight,
        mobileMinHeight: overrideStyles?.mobileMinHeight,
    }
    const imagesCount = components?.length || 0
    if (imagesCount > 2) {
        console.warn(
            `${imagesCount} images are being passed to <Image />. Only the first two will be rendered, 1st for desktop, 2nd for mobile.`,
        )
    }
    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {components?.slice(0, 2).map((image, idx) => {
                const desktop = idx === components.length - 1
                return (
                    <ImageContainer
                        $desktop={desktop}
                        key={imageKeys[idx]}
                        $containerStyles={containerStyles}
                        data-testid={getSearchBannerComponentTestId(isIntelRecs, "image")}
                    >
                        <StyledLink
                            href={replaceSiteUrl(image.url ?? "", siteUrl)}
                            aria-label={image.accessibilityText}
                            title={image.accessibilityTooltip}
                            onClick={() =>
                                TrackVisualPillsClick(image.text || "", replaceSiteUrl(image.url ?? "", siteUrl))
                            }
                        >
                            <SearchBannerImage
                                $desktop={desktop}
                                src={image.image}
                                alt={image.accessibilityText}
                                $imageStyles={imageStyles}
                            />
                        </StyledLink>
                    </ImageContainer>
                )
            })}
        </>
    )
}

export default Image
